export const bankScreen = [
  {
    path: '/bankScreen',
    name: 'bankScreen',
    component: () => import('@/views/bankScreen/index.vue'),
  },
  {
    path: '/bankScreenLogin',
    name: 'bankScreenLogin',
    component: () => import('@/views/bankScreen/login.vue'),
  },
  {
    path: '/branchScreen',
    name: 'branchScreen',
    component: () => import('@/views/bankScreen/branch/index.vue'),
  }
]
